import { type CSSProperties, type JSX } from "react";

/** A single shimmer block. */
export function Skeleton({ width, height, radius }: { width?: string | number; height?: string | number; radius?: string | number }): JSX.Element {
  const style: CSSProperties = { width, height, borderRadius: radius };
  return <span className="voss-skeleton" style={style} aria-hidden />;
}

/** Loading placeholder for the conversation thread while the Brain host is waking. */
export function ThreadSkeleton(): JSX.Element {
  return (
    <div className="voss-thread" aria-busy="true" aria-label="Loading">
      <div className="voss-thread__inner">
        <div className="voss-msg voss-msg--user">
          <Skeleton width="46%" height={44} radius="var(--radius-lg)" />
        </div>
        <div className="voss-msg voss-msg--assistant" style={{ gap: "var(--space-2)" }}>
          <Skeleton width="82%" height={72} radius="var(--radius-lg)" />
          <Skeleton width={180} height={22} radius="var(--radius-pill)" />
        </div>
        <div className="voss-msg voss-msg--user">
          <Skeleton width="38%" height={44} radius="var(--radius-lg)" />
        </div>
      </div>
    </div>
  );
}
